import type { ITag } from 'services/api/entities';
import { TagType } from 'services/api/responses/responseTypes';
import { actionCreator } from 'services/store/types';
import { Nullable } from 'types';
import { SortType } from '../types';
import tagActionNames from './constants';
import { MultipleTagSelection, TagListInfo } from './types';

export const tagGetList = actionCreator<{ tagType: TagType }>(
  tagActionNames.TAG_GET_LIST
);

export const tagGetListSuccess = actionCreator<TagListInfo>(
  tagActionNames.TAG_GET_LIST_SUCCESS
);

export const tagSelection = actionCreator<{ tag: ITag }>(
  tagActionNames.TAG_SELECTION
);

export const tagSelectionFromURL = actionCreator<{
  selectedTags: Record<string, Array<string>>;
}>(tagActionNames.TAG_SELECTION_FROM_URL);

export const tagSelectionFromURLSuccess = actionCreator<MultipleTagSelection>(
  tagActionNames.TAG_SELECTION_FROM_URL_SUCCESS
);

export const updateFilters = actionCreator<{
  minDuration: Nullable<number>;
  maxDuration: Nullable<number>;
  sortBy: Array<SortType>;
}>(tagActionNames.UPDATE_FILTERS);

export const resetTags = actionCreator<void>(tagActionNames.RESET_TAGS);
